import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';

export const blockchainSportsExclusiveCampaign1000Usdt: Story = {
  id: 'blockchain-sports-exclusive-campaign-1000-usdt',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Blockchain sports exclusive campaign 1000 usdt',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Blockchain Sports Campaign on Magic Store Win ¢10',
      description:
        'Participate in our exclusive Blockchain Sports campaign and win ¢10! Plus, enter our giveaway to get a chance to grab your share from a 300 USDT pool',
      keywords:
        'Blockchain Sports, Exclusive Campaign, Win ¢10, Cryptocurrency Giveaway, ¢10  Prize, 300 USDT Giveaway, Free Entry, Crypto Contest, Blockchain Rewards, Financial Campaign, Crypto Community, USDT Rewards',
    },
    config: {
      key: '75ee2e20ac6957975ac2988f8ada0add7e2d',
      scode: 'MagicSquare',
      ccode: 'HxUO79300z',
    },
  },
};
